import { createBeat } from "@kosmod/kit";

export const uiBeat = createBeat();
export const renderBeat = createBeat();
export const inputBeat = createBeat();
